export default {
  init() {
    // JavaScript to be fired on the about us page

    $(".team--grid--item--toggle").on("click", function () {
      $(this).parent().parent().toggleClass("open");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/team.js